export default {"src":"/_next/static/media/SingleStatusBadge.c7d68120.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};